import "./BackgroundBlur.css";

const BackgroundBlur1 = () => {
  return (
    <div className="bg-blur-container bg-blur-1">
      <svg
        width="599"
        height="334"
        viewBox="0 0 599 334"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          opacity="0.3"
          cx="299.225"
          cy="167.303"
          rx="316.024"
          ry="131.801"
          transform="rotate(20.77 299.225 167.303)"
          fill="#947DC2"
        />
      </svg>
      <svg
        width="566"
        height="319"
        viewBox="0 0 566 319"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          opacity="0.3"
          cx="282.847"
          cy="159.572"
          rx="140.832"
          ry="291.712"
          transform="rotate(73.3351 282.847 159.572)"
          fill="#5875AF"
        />
      </svg>
      <svg
        width="388"
        height="408"
        viewBox="0 0 388 408"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          opacity="0.3"
          cx="194"
          cy="204.197"
          rx="204.615"
          ry="192.403"
          transform="rotate(73.3351 194 204.197)"
          fill="#5875AF"
        />
      </svg>
      <svg
        width="607"
        height="322"
        viewBox="0 0 607 322"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          opacity="0.3"
          cx="303.505"
          cy="161.175"
          rx="316.024"
          ry="131.801"
          transform="rotate(-18.4798 303.505 161.175)"
          fill="#947DC2"
        />
      </svg>

      <svg
        width="516"
        height="212"
        viewBox="0 0 516 212"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          opacity="0.3"
          cx="258.177"
          cy="106.068"
          rx="267.297"
          ry="77.0455"
          transform="rotate(16.324 258.177 106.068)"
          fill="#947DC2"
        />
      </svg>
      <svg
        width="459"
        height="376"
        viewBox="0 0 459 376"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <ellipse
          opacity="0.3"
          cx="229.577"
          cy="187.578"
          rx="163.519"
          ry="246.981"
          transform="rotate(119.774 229.577 187.578)"
          fill="#5875AF"
        />
      </svg>
    </div>
  );
}

export default BackgroundBlur1;
